<template>
  <ts-card>
    <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
      <h4 class="ts-text-sm">{{ $t('payPayrollItemCompany.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <ts-loading-banner :loading="loadingPayrollItems">
        <form>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label required">{{ $t('payPayrollItemCompany.itemType') }}</label>
                <div>
                  <ts-select
                    v-model="model.item_type_id"
                    :options="
                      payPayrollItemTypes.map(type => ({
                        value: type.item_type_id,
                        text: type.item_type
                      }))
                    "
                    :class="{ 'is-invalid': errors.has('item_type_id') }"
                    autofocus
                    @change="onItemTypeChange"
                  />
                  <div class="invalid-feedback" v-if="errors.has('item_type_id')">
                    {{ errors.first('item_type_id') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label required">{{
                  $t('payPayrollItemCompany.payrollItem')
                }}</label>
                <div>
                  <ts-select
                    v-model="model.payroll_item_id"
                    :options="payPayrollItems"
                    :class="{ 'is-invalid': errors.has('payroll_item_id') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('payroll_item_id')">
                    {{ errors.first('payroll_item_id') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label required">{{
                  $t('payPayrollItemCompany.companyIdList')
                }}</label>
                <div>
                  <ul class="ts-list-none ts-p-2 ts-border ts-border-gray-200 rounded">
                    <li v-for="company in companies" :key="company.company_id">
                      <ts-checkbox v-model="model.company_id_list" :value="company.company_id">{{
                        company.company_name_en
                      }}</ts-checkbox>
                    </li>
                  </ul>
                  <div class="invalid-feedback" v-if="errors.has('company_id_list')">
                    {{ errors.first('company_id_list') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row ts-mt-6">
            <div class="col-sm-12 col-lg-12 col-md-12 text-right">
              <ts-button @click.prevent="$emit('close')" :disabled="saving">{{ $t('button.cancel') }}</ts-button>
              <ts-button
                outline
                color="primary"
                class="ml-2"
                :waiting="savingAndNew"
                @click.prevent="saveAndNew"
                v-if="editData === undefined"
                >{{ $t('button.createAndNew') }}</ts-button
              >
              <ts-button color="primary" class="ml-2" :waiting="saving" @click.prevent="save">{{
                editData ? $t('button.update') : $t('button.create')
              }}</ts-button>
            </div>
          </div>
        </form>
      </ts-loading-banner>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { cloneDeep } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'pay-payroll-item-company-form',
  props: ['editData'],
  data() {
    const model = {
      item_type_id: this.editData ? this.editData.item_type_id : '',
      payroll_item_id: this.editData ? this.editData.payroll_item_id : '',
      company_id_list: this.editData ? this.editData.company_id_list : []
    }

    return {
      newModel: model,
      model: cloneDeep(model),
      errors: new Errors(),
      saving: false,
      savingAndNew: false,
      loadingPayrollItems: false
    }
  },
  computed: {
    ...mapState('hr/payPayrollItemCompany', ['companies', 'payPayrollItemTypes', 'payPayrollItems'])
  },
  created() {
    this.loadPayrollItem()
  },
  methods: {
    onItemTypeChange() {
      this.model.payroll_item_id = ''
      this.loadPayrollItem()
    },
    loadPayrollItem() {
      let itemType = this.payPayrollItemTypes.find(p => p.item_type_id == this.model.item_type_id)

      if (itemType === undefined) return

      this.loadingPayrollItems = true

      this.$store
        .dispatch('hr/payPayrollItemCompany/fetchPayrollItems', itemType.item_type)
        .finally(() => (this.loadingPayrollItems = false))
    },
    submit() {
      let responseResult

      this.errors = new Errors()

      if (this.editData) {
        responseResult = this.$store.dispatch('hr/payPayrollItemCompany/update', {
          id: this.editData.record_id,
          ...this.model
        })
      } else {
        responseResult = this.$store.dispatch('hr/payPayrollItemCompany/create', this.model)
      }

      return responseResult
        .then(response => {
          return this.$store.dispatch('hr/payPayrollItemCompany/fetch').then(res => {
            this.saving = false
            this.$toasted.success(response.message)
            return Promise.resolve(res)
          })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)

          return Promise.reject(error)
        })
    },
    save() {
      this.saving = true

      this.submit()
        .then(() => {
          this.$emit('close')
        })
        .finally(() => {
          this.saving = false
        })
    },
    saveAndNew() {
      this.savingAndNew = true

      this.submit()
        .then(() => {
          this.model = cloneDeep(this.newModel)
        })
        .finally(() => {
          this.savingAndNew = false
        })
    }
  }
}
</script>
